<template>
    <div>
        <k-panel class="border mb-5">
            <template v-slot:header>
                <k-panel-header>Capital call</k-panel-header>
            </template>
            <p class="leading-7" v-if="investment.nextCapitalCallDate">
                Next capital call will be on {{ investment.nextCapitalCallDate }}, and you can apply till {{ investment.nextCapitalCallRequestDeadline }}
            </p>
            <p class="leading-7" v-else>
                No capital call dates available
            </p>
        </k-panel>
        <div class="grid md:grid-cols-3 col-gap-4" v-if="investment.debentureCount > 0">
            <div style="height: 100%">
                <k-panel class="border mb-5">
                    <template v-slot:header>
                        <k-panel-header>New request</k-panel-header>
                    </template>
                    <form autocomplete="off" >
                        <div>
                            <k-input v-model="form.amount"
                                     id="amount"
                                     type="text" placeholder="Enter amount to withdraw"
                                     class="mr-1"
                                     :field-errors="validation.fieldErrors"
                                     :disabled="!investment.nextCapitalCallDate"
                            >
                            </k-input>
                            <div class="text-xs text-gray-700 mt-1">
                                Min. amount {{ tranche.nominalValue | currencyFormat(tranche.currencySymbol) }}
                                ,
                                max {{ investment.principalSettled | currencyFormat(tranche.currencySymbol) }}
                            </div>
                        </div>
                        <div class="mt-5">
                            <a-button class="request-btn" @click.native.prevent="submitRequest" type="primary"
                                      :disabled="form.amount < 1"
                                      style="width: 200px; padding: 0" size="large">
                                Request
                            </a-button>
                        </div>
                    </form>
                </k-panel>
            </div>
            <k-panel class="md:col-span-2 border mb-5">
                <template v-slot:header>
                    <k-panel-header>Your requests</k-panel-header>
                </template>
                <k-table :data-set="{items: requests}" :pagination-visible="false"
                         row-key="id"
                         class="mt-5">
                    <a-table-column title="Request date" key="requestDate" data-index="requestDate" :ellipsis="true"/>
                    <a-table-column title="Capital call date" key="capitalCallDate" data-index="capitalCallDate"
                                    :ellipsis="true"/>
                    <a-table-column title="Amount" key="amount" data-index="amount" :ellipsis="true" align="right">
                        <template slot-scope="text">
                            {{ text | numeralFormat('$0,0.00') }}
                        </template>
                    </a-table-column>
                    <a-table-column title="Status" key="status" data-index="status" :ellipsis="true" align="right">
                        <template slot-scope="text">
                            {{ text }}
                        </template>
                    </a-table-column>
                    <a-table-column key="actions" data-index="actions"
                                    :ellipsis="true"
                                    align="right">
                        <template slot-scope="text, item">
                            <a-button type="primary" @click="cancelRequest(item)"
                                      :disabled="item.status !== 'NEW'">Cancel
                            </a-button>
                        </template>
                    </a-table-column>
                </k-table>
            </k-panel>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        tranche: {
            type: Object,
            required: true
        },
        investment: {
            type: Object,
            required: true
        },
        requests: {
            type: Array,
            required: true
        },
    },
    data() {
        return {
            validation: {
                fieldErrors: {}
            },
            form: {
                trancheUuid: this.tranche.uuid,
                amount: 0
            }
        }
    },
    methods: {
        async submitRequest() {
            this.validation = {
                fieldErrors: {}
            };
            try {
                await this.$post('tranche/request-capital-call', this.form);
                this.$emit('on-request');
                this.form.amount = 0;
            } catch (error) {
                console.error('Failure', error)
                if (error.response && error.response.status === 400) {
                    this.validation = error.response.data;
                }
            }
        },
        async cancelRequest(capitalCallItem) {
            try {
                await this.$post('tranche/cancel-capital-call', {capitalCallId: capitalCallItem.id});
                this.$emit('on-cancel', capitalCallItem);
            } catch (error) {
                console.error('Failure', error)
            }
        },
    },
};
</script>
<style scoped>
.request-btn:disabled {
    @apply bg-primary-200 text-white border-none;
}
</style>

